import type { SxProps, Theme } from '@mui/material';

export const dataGridSx: SxProps<Theme> = {
	width: '100%',
	borderRadius: 3,
	'& .MuiDataGrid-columnHeaderTitle': {
		whiteSpace: 'normal',
		lineHeight: 1.4,
		fontSize: '0.9rem',
		color: 'grey',
	},
	'& .MuiDataGrid-columnHeader': {
		backgroundColor: 'grey.100',
	},
	'& .MuiDataGrid-cellSkeleton': {
		backgroundColor: '#fff',
	},
};
